import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpRequest } from '@angular/common/http';
import { Globals } from '../globals';
import { map, catchError } from 'rxjs/operators';
import { ConfigurationsService } from 'src/app/Service/configurations.service';

@Injectable({
    providedIn: 'root'
})


export class CommonService {
    private httpHeader = new HttpHeaders();

    constructor(private http: HttpClient, private _global: Globals, private configService: ConfigurationsService) {

        this.httpHeader.append('Access-Control-Allow-Origin', '*');

    }

    // Method is used for Get Site List
    GetDeviceTypeList() {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/GetDeviceTypeList';
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for Get Site List
    GetSiteList(CompanyId: any) {
        // Set up header.
        let httpOptions = {
            headers: new HttpHeaders({
                'HideLoader': 'true'
            })
        };

        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/GetSiteListDropdown?CompanyId=' + CompanyId;
        return this.http.get(serviceCallURL, httpOptions)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for Get Panel List
    GetPanelList(SiteId: any) {
        // Set up header.
        let httpOptions = {
            headers: new HttpHeaders({
                'HideLoader': 'true'
            })
        };

        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/GetPanelListDropdown?SiteId=' + SiteId;
        return this.http.get(serviceCallURL, httpOptions)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for Get User List
    GetRoleList(UserRole: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/GetRoleListDropdown?UserRole=' + UserRole;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for Get Energymeter List
    GetEnergyMeterIdList(SiteId: any, PanelId: any, IsFromControl: string) {
        // Set up header.
        let httpOptions = {
            headers: new HttpHeaders({
                'HideLoader': 'true'
            })
        };
        var CompanyID = localStorage.getItem('CompanyIdForUC');
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/GetEnergyMeterIdList?SiteId=' + SiteId + '&PanelId=' + PanelId + '&IsFromControl=' + "'" + IsFromControl + "'" + '&CompanyId=' + CompanyID;
        return this.http.get(serviceCallURL, httpOptions)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for Get Energymeter List
    GetEnergyMeterIdListByTextValue(SiteId: any, PanelId: any, IsFromControl: string, IsRegAvg: string) {
        // Set up header.
        let httpOptions = {
            headers: new HttpHeaders({
                'HideLoader': 'true'
            })
        };
        var CompanyID = localStorage.getItem('CompanyIdForUC');
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/GetEnergyMeterIdListByTextValue?SiteId=' + SiteId + '&PanelId=' + PanelId + '&IsFromControl=' + "'" + IsFromControl + "'" + '&CompanyId=' + CompanyID + '&IsRegAvg=' + IsRegAvg;
        return this.http.get(serviceCallURL, httpOptions)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
    // Method is used for get Company list
    GetCompanyList() {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/GetCompanyDropdownList';
        return this.http.get(serviceCallURL)
            .pipe(
                map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for get Country list
    GetCountryList() {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/GetCountryDropdownList';
        return this.http.get(serviceCallURL)
            .pipe(
                map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    GetRegisterdataforgraph(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/GetRegisterDataforgraph?EnergymeterID=' + ReqObj;
        return this.http.get(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
    DeleteConfigData(Type: any, ConfigId: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/DeleteConfigData?type=' + Type + '&id=' + ConfigId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
    GetDeviceListDropdown(PanelId: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Common' + '/GetDeviceListDropdown?PanelId=' + PanelId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
}
